// src/container/contact.js

import { connect } from 'react-redux';
import contact from '../component/contact/';
import { sendMail } from '../actions/contact';

const mapStateToProps = state => ({
  login_response:state
});

const mapDispatchToProps = dispatch => ({
  sendContact: (value) => { 
    return dispatch(sendMail(value))
  }
});

export default connect(mapStateToProps,mapDispatchToProps)(contact);


// WEBPACK FOOTER //
// ./src/container/contact.js